module.exports = __webpack_public_path__ + "static/media/title02.21c363b8.webp";